if (!customElements.get('customer-review-text')) {
  customElements.define('customer-review-text', class extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('[data-review-text], .customer-reviews__text');
      const button = this.querySelector('button');
      if (!text || !button) return;

      button.addEventListener('click', () => {
        button.setAttribute('aria-expanded', String(this.toggleAttribute('expanded')));
      });

      this.setAttribute('data-ready', '');

      document.fonts.ready.then(() => {
        const lines = parseInt(this.dataset.lines, 10) || 4;
        const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
        button.hidden = text.scrollHeight <= lineHeight * lines + 1;
      });
    }
  });
}

if (!customElements.get('customer-reviews-slider')) {
  customElements.define('customer-reviews-slider', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.customer-reviews__grid');
      if (!track) return;

      this.addEventListener('click', (event) => {
        const arrow = event.target.closest('.customer-reviews__arrow');
        if (!arrow) return;

        const [first, second] = track.children;
        const step = second ? second.offsetLeft - first.offsetLeft : track.clientWidth;
        track.scrollBy(arrow.classList.contains('customer-reviews__arrow--prev') ? -step : step, 0);
      });
    }
  });
}
